import { ContentPage, contentMeta, type ContentPageData } from '@/site/content'
import { FEATURE_PAGES } from '@/site/features'

const page: ContentPageData = {
  path: '/funktsii',
  crumb: 'Можливості',
  title: 'Можливості Anytel: AI-агент, IVR, записи, CRM | Anytel',
  description:
    'Що вміє Anytel: AI-агент на дзвінках, IVR-меню і сценарії, запис і транскрипція розмов, інтеграція з CRM, заявки в Telegram, робота 24/7.',
  eyebrow: 'Можливості',
  h1: 'Можливості Anytel',
  lead:
    'Усе для телефонних розмов з клієнтами в одному кабінеті: голосовий AI-агент, сценарії дзвінків, записи й розшифровки, календарі, заявки та інтеграції.',
  cards: FEATURE_PAGES,
  sections: [
    {
      h2: 'Що ще є в кабінеті',
      blocks: [
        {
          list: [
            'Календарі співробітників з графіками, вихідними й вільними вікнами.',
            'Черга операторів: співробітники приймають дзвінки прямо в браузері, без телефонів на столі.',
            'Автоматичні передзвони на пропущені дзвінки в робочий час.',
            'Чат-боти в Telegram, Viber, Messenger та Instagram з тими самими знаннями, що й голосовий агент.',
            'Віджет «Передзвоніть мені» для вашого сайту: відвідувач залишає номер, і агент телефонує йому сам.',
            'Контакти з історією дзвінків, заявок і повідомлень.',
            'Команда з правами доступу за розділами: перегляд або редагування.',
            'Тестовий дзвінок з браузера ще до підключення номера.',
          ],
        },
        'Як це працює в різних бізнесах, дивіться на сторінках [галузей](/dlya).',
      ],
    },
  ],
}

export const meta = contentMeta(page)

export default function Page() {
  return <ContentPage page={page} />
}
